export default __webpack_public_path__ + "static/media/tablePreview_5.5caf926e.png";